export default __webpack_public_path__ + "af932dd231f326988b9c4d2157f1604d.png";